import { AboutUsComponent } from "./AboutUs";
import { ItemsGallery } from "./Gallery";
import { MenuComponent } from "./Menus/Menu";
import { NavComponent } from "./Nav";
import { useRestaurantData } from "../useRestaurantData";

export const LandingPage = () => {
  const { data, loading } = useRestaurantData();

  if (loading || !data) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl font-bold animate-pulse">Laddar...</div>
      </div>
    );
  }

  return (
    <>
      <NavComponent />
      <div className="relative">
        <div>
          <div className="relative bg-white">
            {data.announcement && (
              <div className="rounded-md text-center backdrop-blur-sm p-10 bg-white/30 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                <h1 className="text-lg font-bold">{data.announcement.title}</h1>
                <div className="font-bold whitespace-pre-wrap">
                  {data.announcement.message}
                </div>
              </div>
            )}
            <div className="overflow-hidden h-72">
              <img
                alt="Background"
                className="w-full"
                src="https://th.bing.com/th/id/R.5019ce7108793f36390b033f5eafb176?rik=R5FQhsu%2f6S3fJQ&pid=ImgRaw&r=0"
              />
            </div>
          </div>
          <div id="menu" className="border-t-2 border-t-black pt-12">
            <MenuComponent menu={data.menu} />
          </div>
          <div id="gallery" className="mt-10 border-t-2 border-t-black">
            <ItemsGallery images={data.gallery} />
          </div>
          <div id="contact" className="border-t-2 border-t-black pt-12">
            <AboutUsComponent aboutUs={data.aboutUs} />
          </div>
        </div>
      </div>
    </>
  );
};
